import { render } from "./TalentPools.vue?vue&type=template&id=288e2d94"
import script from "./TalentPools.vue?vue&type=script&lang=js"
export * from "./TalentPools.vue?vue&type=script&lang=js"

import exportComponent from "G:\\workspace\\screened-cv-parser\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__